'use client';

import * as React from 'react';
import * as SwitchPrimitives from '@radix-ui/react-switch';
import { useTranslation } from 'react-i18next';

import { cn } from '@app/shared/utils/common';

const PowerSwitch = React.forwardRef<
  React.ComponentRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => {
  const { t } = useTranslation();

  return (
    <SwitchPrimitives.Root
      className={cn(
        'group relative inline-flex h-[47px] w-[112px] shrink-0 cursor-pointer items-center rounded-full shadow-[0_4px_4px_#0a78e65e_inset] transition-colors disabled:cursor-not-allowed data-[state=checked]:bg-tertiary-accent data-[state=unchecked]:bg-tertiary',
        'duration-400',
        className
      )}
      {...props}
      ref={ref}
    >
      <span
        className={cn(
          'text-foreground absolute z-10 -left-[8px] w-[62px] text-center text-xs font-medium group-data-[state=checked]:hidden'
        )}
      >
        {t('edit_profile.off')}
      </span>
      <span
        className={cn(
          'absolute -right-[8px] w-[62px] z-10 text-center text-background text-xs font-medium group-data-[state=unchecked]:hidden'
        )}
      >
        {t('edit_profile.on')}
      </span>
      <SwitchPrimitives.Thumb
        className={cn(
          'pointer-events-none block h-[37px] w-[37px] rounded-full transition-transform data-[state=checked]:translate-x-[70px] data-[state=unchecked]:translate-x-[5px] data-[state=checked]:bg-tertiary data-[state=unchecked]:bg-tertiary-accent',
          'duration-400'
        )}
      />
    </SwitchPrimitives.Root>
  );
});
PowerSwitch.displayName = SwitchPrimitives.Root.displayName;

export { PowerSwitch };
